import { render, staticRenderFns } from "./ActualizacionDatos.vue?vue&type=template&id=3f266171&scoped=true"
import script from "./ActualizacionDatos.vue?vue&type=script&lang=ts"
export * from "./ActualizacionDatos.vue?vue&type=script&lang=ts"
import style0 from "./ActualizacionDatos.vue?vue&type=style&index=0&id=3f266171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f266171",
  null
  
)

export default component.exports